// extracted by mini-css-extract-plugin
export default {"btn":"cell-addition_btn__9HFjI"};